import { SvgIcon } from '@mui/material'

import styles from './animatedIcons.module.css'

type Props = {
  fontSize?: number | string
}

export default function AnimatedTaskDoneIcon(props: Props) {
  const { fontSize = '1.5rem' } = props
  return (
    <SvgIcon
      color="success"
      sx={{
        fontSize: fontSize,
        '& path': {
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 1.5,
        },
      }}
      viewBox="0 0 24 24"
    >
      <path
        className={styles.taskDoneCircle}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 16.23,4.02
            C 16.23,4.02 15.00,2.99 12.00,2.99
              7.38,2.99 3.09,6.74 3.09,12.06
              3.09,17.37 7.27,21.13 12.00,21.13
              16.73,21.13 21.03,17.06 21.03,12.06
              21.03,11.27 20.91,10.45 20.91,10.45"
      />
      <path
        className={styles.taskDoneCheck}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 7.66,12.24
            C 7.66,12.24 10.55,15.01 10.55,15.01
              10.55,15.01 20.81,5.05 20.81,5.05"
      />
    </SvgIcon>
  )
}
